<!--  -->
<template>
  <div class="course-sku">
    <van-popup v-model="show" position="bottom" :style="{ height: '65%' }" duration="0.18" round>
      <section class="section">
        <h1 class="course-title">
          <span>选择课程</span><van-icon @click="show = false" name="cross" />
        </h1>
        <div class="course-box" v-if="show">
          <CourseSku
            v-for="(item, index) in productList"
            :key="index"
            :courseInfo="item"
            @triggerChecked="receiveCourse"
          />
        </div>
        <footer class="foot"><button @click="toBuy">确认激活</button></footer>
      </section>
    </van-popup>
  </div>
</template>

<script>
import { resCourseTmall } from '@/api/personal/courseTmall';
import CourseSku from './courseSku.vue';

export default {
  components: {
    CourseSku,
  },
  data() {
    return {
      show: false,
    };
  },
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  watch: {},
  methods: {
    async toBuy() {
      if (!this.productList.every((item) => item.productSkuId)) {
        this.$toast('请选择规格后激活');
        return;
      }
      const isEbook = this.productList.some((item) => item.isEbook);
      const chooseProductList = this.productList.map((product) => ({
        productId: product.productId,
        productSkuId: product.productSkuId,
        productName: product.productName,
      }));
      const result = await resCourseTmall({
        chooseProductList,
        terminalMark: this.$global.terminalMark,
        tid: this.$parent.tmallCard,
        channelType: this.$parent.selected + 1,
        courseType: 1,
      });
      if (result?.code === 0) {
        this.show = false;
        this.$parent.tmallCard = '';
        this.$parent.selected = -1;
        this.$emit('success', { ...result?.data, isEbook });
      } else {
        this.$toast(result?.msg);
      }
    },
    receiveCourse(course) {
      const { setId, productSkuId } = course;
      this.productList.forEach((item) => {
        if (item.setId === setId) {
          Object.assign(item, { productSkuId });
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.course-sku {
  ::v-deep .van-popup--bottom.van-popup--round {
    border-radius: 7px 7px 0 0 !important;
  }
}

.course-title {
  position: fixed;
  z-index: 100;
  width: 100%;
  padding: 20px 0;
  color: #333;
  font-weight: 500;
  font-size: 33px;
  line-height: 45px;
  text-align: center;
  background: #f9f9f9;
  ::v-deep .van-icon {
    position: absolute;
    top: 14px;
    right: 18px;
    color: #333;
  }
}
.course-box {
  padding: 100px 0 130px 0;
}
.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 120px;
  padding: 20px 0 0 0;
  background: #fff;
  button {
    display: block;
    width: 678px;
    height: 82px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    background: #ff6c02;
    border-radius: 41px;
  }
}
</style>
